import connect from './connect';

import CompletedDocumentsTable from './CompletedDocumentsTable';

export { CompletedDocumentsTable };

export default connect(CompletedDocumentsTable);
